import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"

export default createModule({
  view,
  mapStateToProps: state => ({
    ...state.modules.notifications,
  }),
  actions: Creators,
})
